<div>
  @if(isLoading) {
  <app-loading-indicator />
  } @else {
  <div class="control-row">
    <div class="control mx-5">
      <label class="mb-1" for="selectTarget" style="font-weight: bold; color: #719eb6"
        >Selected Target(Depending on the type of the selected target, different graph types and options will be available):</label
      >
      <p-multiSelect
        id="selectTarget"
        styleClass="w-100 mb-3"
        appendTo="body"
        [options]="selectableTargets()"
        [(ngModel)]="selectedTargets"
        name="selectedTargets"
        optionLabel="text"
        optionValue="value"
        [showClear]="true"
        placeholder="Select a Target to start, select more than one target to enter comparison mode"
        [filter]="true"
        filterBy="text"
        display="chip"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="50"
        [loading]="isLoading"
        [disabled]="isLoading"
        (onChange)="onTargetChange($event)"
        ><ng-template pTemplate="selectedTarget" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.text }}</div>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>
  </div>
  <app-target-graph
    *ngIf="selectedTargets().length > 0"
    [patientID]="patientID()"
    [selectedTargets]="selectedTargets()"
  ></app-target-graph>
  }
</div>
